import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useEffect, useState } from 'react'
import { fetchInstallation } from 'src/Libs/installations/api/installation.api'

interface UseShowInstallationNotConfigured {
  hasGpsCoordinates: boolean
}

/**
 * Hook for handling vehicles fetching after the user previously authorized via the manufacturer login
 */
export const useShowInstallationNotConfigured = (installationId?: string): UseShowInstallationNotConfigured => {
  const [hasGpsCoordinates, setHasGpsCoordinates] = useState<boolean>(false)
  const authFetch = useAuthFetchWithResponse()

  useEffect(() => {
    const getInstallation = async (): Promise<void> => {
      const { value: installation } = await fetchInstallation(Number(installationId), authFetch)
      if (installation) {
        if (installation.gpsLatitude !== -1 || installation.gpsLongitude !== -1) {
          setHasGpsCoordinates(true)
        }
      }
    }

    getInstallation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [installationId])

  return { hasGpsCoordinates }
}
